import classNames from "classnames";
import styles from "./FAQItemFiltered.module.scss";
import { highlight } from "@/helpers/highlight";
import { useAppSelector } from "store/store";

type FAQItemFilteredProps = {
  id: string;
  heading: string;
  content: string;
  className?: string;
};

export const FAQItemFiltered = ({ id, heading, content, className }: FAQItemFilteredProps) => {
  const { searchQuery } = useAppSelector((state) => state.faq);
  return (
    <div className={classNames(styles.wrapper, className)} id={id} key={id}>
      <h3
        className={styles.heading}
        dangerouslySetInnerHTML={{ __html: highlight(heading, searchQuery, styles.highlighted) }}
      />
      <div className={styles.contentWrapper}>
        <div
          className={styles.content}
          dangerouslySetInnerHTML={{ __html: highlight(content, searchQuery, styles.highlighted) }}
        />
      </div>
    </div>
  );
};
